import React from "react";
import { useHistory } from "react-router-dom";
import {
  setTimerInitialMinute,
  setTimerInitialSecond,
  setFlightBookingInitialTime,
} from "redux/action";
import { connect } from "react-redux";
import WebApi from "api/ApiConstants";
import { localforageGetItem } from "oautils/oaForageUtils";
import { AppConstant } from "appConstant";
import FlightSearchProgress from "./FlightSearchProgress";
import FlightSearch from "pages/module/flight/compact/FlightSearch";
import FlightSearchComRes from "./FlightSearchComRes";
// import demoResponse from "pages/module/flight/JSON_SAMPLE_RESPONSES/domestic/dom_oneway_avail_response.json";
// import demoResponse from "pages/module/flight/JSON_SAMPLE_RESPONSES/domestic/dome_round_avail_response.json";
// import demoResponse from "pages/module/flight/JSON_SAMPLE_RESPONSES/international/int_flight_oneway_avail.json";

const FlightAvailability = (props) => {
  const history = useHistory();
  const [isLoading, setIsLoading] = React.useState(true);
  const [isDomestic, setIsDomestic] = React.useState(true);
  const [flightSearchResults, setFlightSearchResults] = React.useState(null);
  const [isCombinedResp, setIsCombinedResp] = React.useState(false);

  const params = {};
  params.adultPax = history.location.state.adultPax;
  params.childPax = history.location.state.childPax;
  params.infantPax = history.location.state.infantPax;
  params.clientType = history.location.state.clientType;
  params.mode = history.location.state.mode;
  params.preferredAirline = history.location.state.preferredAirline;
  params.preferredclass = history.location.state.preferredclass;
  params.returnDate = history.location.state.returnDate;
  params.partnerId = history.location.state.partnerId;
  params.isNonStop = history.location.state.isNonStop;
  params.fareType = history.location.state.fareType;

  params.sectors = [];

  if (history.location.state.mode == "MULTICITY") {
    params.mode = "ONE";

    history.location.state.sectors.map((val) => {
      params.sectors.push({
        departDate: val.departDate,
        destination: val.destination,
        origin: val.origin,
      });
    });
  } else {
    params.sectors.push({
      departDate: history.location.state.sectors[0].departDate,
      destination: history.location.state.sectors[0].destination,
      origin: history.location.state.sectors[0].origin,
    });
  }

  const getAccessCreds = () => {
    return new Promise((resolve, reject) => {
      localforageGetItem("access-key", function(err, accessKey) {
        if (accessKey) {
          localforageGetItem("user-details", function(errr, details) {
            if (details) {
              details.accessKey = accessKey;
              resolve(details);
            }
            if (errr) {
              reject(errr);
            }
          });
        }
        if (err) {
          reject(err);
        }
      });
    });
  };

  const getFlightSearchSessionId = (params) => {
    console.log("request started at", new Date());
    // const url = 'http://oari.co:9991/FlightAvalabilityAjaxRequest';

    WebApi.getAjaxFlightSearchSession(
      params,
      (response) => {
        console.log("response", response);
        let count = 0;
        if (response.sessionId !== null && response.sessionId !== "") {
          getFlightSearchResponse(response.sessionId);
          count++;
          console.log("flight reponse fetch count", count);
        }
        console.log("response", response);
      },
      (error) => {
        console.error("Flight search Ajax error", error);
      }
    );
  };

  const getFlightSearchResponse = (sessionId) => {
    WebApi.getAjaxFlightSearchResponse(
      { sessionId: sessionId },
      (response) => {
        const result = response.result;
        const allResponse = response.allResponse;
        if (!allResponse) {
          console.log("all response false ", new Date());
          if (result) {
            console.log(result, "RESULTT");
            processFlightSearchResults(result, sessionId);
          }
          setTimeout(() => {
            getFlightSearchResponse(sessionId);
          }, 5000); // 5 seconds delay
        } else {
          console.log("all response true ", new Date());
          if (result) {
            processFlightSearchResults(result, sessionId);
          }
        }
      },
      (error) => {
        console.error("Flight search Ajax error", JSON.stringify(error));
      }
    );
  };

  const processFlightSearchResults = (searchResult, sessionId) => {
    let isDomestic = true;
    history.location.state &&
      history.location.state.sectors.map((val) => {
        if (
          val.destinationObj?.countryCode !== undefined &&
          val.originObj?.countryCode !== undefined
        ) {
          if (
            val.destinationObj.countryCode != "IN" ||
            val.originObj.countryCode != "IN"
          ) {
            isDomestic = false;
          }
        }
      });

    history.location.state.isDomestic = isDomestic;
    setIsDomestic(isDomestic);

    if (isDomestic && history.location.state.mode != "MULTICITY") {
      if (history.location.state.mode === "ONE" && searchResult.onwardResp) {
        setFlightSearchResults((prevState) => {
          // console.log("prevState", prevState)
          let temp = null;
          if (prevState && prevState.onwardResp?.length > 0) {
            let filtered = searchResult.onwardResp.filter((val) =>
              searchResult.onwardResp.some(
                (item) => JSON.stringify(item) !== JSON.stringify(val)
              )
            );
            if (filtered.length > 0) {
              prevState.onwAppended.push(...filtered);
            }
            temp = { ...prevState };
            temp.requestObj = history.location.state;
            temp.sessionId = sessionId;
            console.log("prevStateChanged", temp.onwAppended.length);
          } else {
            temp = { ...searchResult };
            temp.requestObj = history.location.state;
            temp.sessionId = sessionId;
            temp.onwAppended = [];
          }
          return temp;
        });
      } else if (
        history.location.state.mode === "ROUND" &&
        searchResult.onwardResp &&
        searchResult.returnResp
      ) {
        setFlightSearchResults((prevState) => {
          // console.log("prevState", prevState)
          let temp = null;
          if (
            prevState &&
            prevState.onwardResp?.length > 0 &&
            prevState.returnResp?.length > 0
          ) {
            let filteredOnw = searchResult.onwardResp.filter((val) =>
              searchResult.onwardResp.some(
                (item) => JSON.stringify(item) !== JSON.stringify(val)
              )
            );
            let filteredRet = searchResult.returnResp.filter((val) =>
              searchResult.returnResp.some(
                (item) => JSON.stringify(item) !== JSON.stringify(val)
              )
            );
            if (filteredOnw.length > 0) {
              prevState.onwAppended.push(...filteredOnw);
            }
            if (filteredRet.length > 0) {
              prevState.retAppended.push(...filteredRet);
            }
            temp = { ...prevState };
            temp.requestObj = history.location.state;
            temp.sessionId = sessionId;
            console.log("prevStateChanged onward", temp.onwAppended.length);
            console.log("prevStateChanged return", temp.retAppended.length);
          } else {
            temp = searchResult;
            temp.requestObj = history.location.state;
            temp.sessionId = sessionId;
            temp.onwAppended = [];
            temp.retAppended = [];
          }
          return temp;
        });
      }
    } else {
      setIsCombinedResp(true);
      if (searchResult.combineResp) {
        setFlightSearchResults((prevState) => {
          // console.log("prevState", prevState)
          let temp = null;
          if (prevState && prevState?.combineResp?.length > 0) {
            let filtered = searchResult?.combineResp?.filter((val) =>
              searchResult?.combineResp.some(
                (item) => JSON.stringify(item) !== JSON.stringify(val)
              )
            );
            if (filtered?.length > 0) {
              prevState.comAppended.push(...filtered);
            }
            temp = { ...prevState };
            temp.requestObj = history.location.state;
            temp.sessionId = sessionId;
            console.log("new combined response", temp.combineResp.length);
          } else {
            temp = searchResult;
            temp.requestObj = history.location.state;
            temp.sessionId = sessionId;
            temp.comAppended = [];
          }
          return temp;
        });
      }
    }
  };

  React.useEffect(() => {
    const fetching = window.sessionStorage.getItem("fetching");
    console.log("session storage fetching", fetching);
    if (fetching) {
      getAccessCreds()
        .then((details) => {
          const userType = details.userType;
          const corporateType = details.corporateType;
          params.partnerId = details.partnerId;
          params.clientType = "Normal";

          switch (details.userTypeAbv) {
            case "S": {
              params.clientType = "Corporate";
              break;
            }

            case "G": {
              params.clientType = "Normal";
              break;
            }

            default: {
              params.clientType = "Normal";
              break;
            }
          }

          if (
            (details.userTypeAbv === "G" || details.userTypeAbv === "A") &&
            AppConstant.B2BOnly === true
          ) {
            history.push({
              pathname: "/",
            });
            return;
          }
          params.loggedInUserId = details.userId;
          //   console.log("Woho");
          getFlightSearchSessionId(params, details.accessKey);

          // WebApi.searchFlight(
          //     params,
          //     (response) => {
          //         props.setTimerInitialMinute(0);
          //         props.setTimerInitialSecond(0);
          //         props.setFlightBookingInitialTime(
          //             new Date().getTime() + 15 * 60 * 1000
          //         );
          //         window.sessionStorage.setItem("service", "flight");

          //         // if (isDomestic && history.location.state.mode != "MULTICITY") {
          //         //     history.push({
          //         //         pathname: "/flight/search-result",
          //         //         state: {
          //         //             ...response,
          //         //             requestObj: history.location.state,
          //         //         },
          //         //         //state: demoResponse,
          //         //     });
          //         // } else {
          //         //     history.push({
          //         //         pathname: "/flight/international/search-result",
          //         //         state: {
          //         //             ...response,
          //         //             requestObj: history.location.state,
          //         //         },
          //         //     });
          //         // }
          //     },
          //     (error) => {
          //         console.log(error);
          //         history.push({
          //             pathname: "/flight/search-result",
          //             state: {
          //                 // ...response,
          //                 requestObj: history.location.state,
          //             },
          //             //state: demoResponse,
          //         });
          //         return;

          //         // console.log("internal error", error);
          //     }
          // );
        })
        .catch((error) => {
          console.error("Access Credentials Error", error);
          history.push("/logout");
        });
    } else {
      history.push("/");
    }
  }, [isLoading]);

  React.useEffect(() => {
    if (flightSearchResults) {
      console.log(
        flightSearchResults.onwAppended,
        "FLIGHT SEARCH RESULTS ---------"
      );
      // if(history.location.state.mode === 'ONE' && flightSearchResults.onwardResp?.length > 0
      //     || history.location.state.mode === 'ROUND' && flightSearchResults.returnResp?.length > 0
      //     || flightSearchResults.combineResp?.length > 0
      // ) {
      //     setResultsRenderable(true);
      // }
      console.log("flight results updated");
    }
  }, [flightSearchResults]);

  // return (isDomestic ? history.location.state.mode === 'ONE' ?
  //     <>
  // <h1>Initial Result {flightSearchResults?.onwardResp && flightSearchResults.onwardResp?.length}</h1>
  // <h1>Appended Result {flightSearchResults?.onwAppended && flightSearchResults.onwAppended?.length}</h1>
  //     </>
  //     :
  //     <>
  //         <h1>Initial Result onward {flightSearchResults?.onwardResp && flightSearchResults.onwardResp?.length}</h1>
  //         <h1>Appended Result onward {flightSearchResults?.onwAppended && flightSearchResults.onwAppended?.length}</h1>
  //         <h1>Initial Result return {flightSearchResults?.returnResp && flightSearchResults.returnResp?.length}</h1>
  //         <h1>Appended Result return {flightSearchResults?.retAppended && flightSearchResults.retAppended?.length}</h1>
  //     </>
  //     :
  //     <>
  //         <h1>Initial Result combined {flightSearchResults?.combineResp && flightSearchResults.combineResp?.length}</h1>
  //         <h1>Appended Result {flightSearchResults?.comAppended && flightSearchResults.comAppended?.length}</h1>
  //     </>
  // )

  return flightSearchResults ? (
    isCombinedResp ? (
      <FlightSearchComRes
        comloader={props.comloader}
        availoader={props.comloader}
        {...flightSearchResults}
      />
    ) : (
      <FlightSearch
        availoader={props.comloader}
        comloader={props.comloader}
        {...flightSearchResults}
      />
    )
  ) : (
    <FlightSearchProgress
      requestObj={history.location.state}
      availoader={props.availoader}
    />
  );
};

function mapStateToProps(state, props) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    setTimerInitialMinute: (timerInitialMinute) =>
      dispatch(setTimerInitialMinute(timerInitialMinute)),
    setTimerInitialSecond: (timerInitialSecond) =>
      dispatch(setTimerInitialSecond(timerInitialSecond)),
    setFlightBookingInitialTime: (flightBookingInitialTime) =>
      dispatch(setFlightBookingInitialTime(flightBookingInitialTime)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FlightAvailability);
